import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "sc-1bd4jw3-0"
})(["display:flex;flex-wrap:wrap;"]);
const Grid = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledGrid, Object.assign({}, props, {
    children: children
  }));
};
export default Grid;